// color HEX
export const WHITE_HEX = '#ffffff';
export const GREY_WHITE_HEX = '#F1F1F1';
export const GREEEN_HEX = '#1aa55d';
export const ORANGE_HEX = '#e57424';
export const BLACK_HEX = '#000000';
export const COD_GRAY_HEX = '#1a1a1a';
// fonts
export const CENTURY_GOTHIC = 'CenturyGothic';
export const CENTURY_GOTHIC_BOLD = 'CenturyGothicBold';
export const MYRIAD_PRO = 'MyriadPro';
export const MYRIAD_PRO_BOLD = 'MyriadProBold';
export const SEGOE_UI = 'SegoeUI';
export const SEGOE_UI_BOLD = 'SegoeUIBold';
export const SEGOE_UI_ITALIC = 'SegoeUIItalic';
export const SEGOE_UI_ITALIC_BOLD = 'SegoeUIItalicBold';
// multiplayers
export const smFontUnder30 = 0.8;
export const smFontAbove30 = 0.625;
// breakingPoints
export const xsBreakingPoint = '360px';
export const smBreakingPoint = '414px';
export const mdBreakingPoint = '1366px';
export const lgBreakingPoint = '1920px';
// url
export const BACKEND_URL = process.env.REACT_APP_BACKEND;
export const LAODER_URL = 'https://www.dropbox.com/s/8rjodyo5v0clcgn/rippleLoading.gif?raw=1';
// lang
export const langEnum = {
    ARM: 'ARM',
    ENG: 'ENG',
    RUS: 'RUS'
}